<div class="page-content-wrap contentdata">
  <!-- PAGE CONTENT WRAPPER -->
  <div class="common-page-contentwrap">
    <div class="col-md-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a *ngIf="this.loginPersonType == 'EMPLOYEE'">Material</a><a
            *ngIf="this.loginPersonType != 'EMPLOYEE'">Inventory Control</a></li>
          <li><a>Material Transactions</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
    </div>
    <!-- START DEFAULT FORM ELEMENTS -->
    <div class="block">
      <div class="row" style="background: #0f4573;" *ngIf="appPermission?.[0].BAdminName">
        <p class="providerbusinessname">{{ loginUserBusinessName }}</p>
      </div>
      <div class="screen_heading_div">
        <span>Material Transactions</span>
      </div>
      <div class="nav_tabs_container">
        <ul>
          <li class="active" data-toggle="tab" (click)="inventoryTab()"><a>Inventory</a></li>
          <li data-toggle="tab" (click)="expenseTab()"><a>Expense</a></li>
        </ul>
      </div>
      <div class="row">
        <div *ngIf="tabIndex == 0" class="info-container">
          <img src="../../../../../assets/images/New_Icons/info-icon.svg" height="20" width="20"/>
          <span>Use to record Feed , Treatments and other stockable items</span>
        </div>
        <div *ngIf="tabIndex == 1" class="info-container">
          <img src="../../../../../assets/images/New_Icons/info-icon.svg" height="20" width="20"/>
          <span>Use to record Seed , Labor ,Power , Depreciation ,Groceries and other variable costs</span>
        </div>
      </div>
      <div class="Reports_form_div">
        <form role="form" name="addmapdevice" [formGroup]="registerForm" class="form-horizontal">
          <div class="reports-form-container">
            <mat-form-field appearance="outline" class="w-100" floatLabel="always" *ngIf="loginPersonType != 'Farmer' && loginPersonType != 'Farm Manager' && loginPersonType != 'Business Admin' && loginUserBusinessCategory != 'Farm'">
              <mat-label>Search Business Name</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessnameField"
                     placeholder="Search business" (keyup)="filterBusinesses($event)" (focus)="filteredOptions = businessEntities"
                     [matAutocomplete]="businessAuto"/>
              <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                <mat-option *ngFor="let option of filteredOptions" [value]="option">
                  {{ option.businessName }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint *ngIf="f.businessnameField.invalid"><i>Select business</i></mat-hint>
              <mat-hint *ngIf="f.businessnameField.valid"><i>Business selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.businessnameField.touched || f.businessnameField.dirty) && f.businessnameField.errors">
                <i *ngIf="f.businessnameField.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100" *ngIf="(loginPersonType === 'Farmer' || loginPersonType === 'Farm Manager' || loginPersonType === 'Business Admin') && loginUserBusinessCategory === 'Farm'">
              <mat-label>Farm Name</mat-label>
              <input matInput [value]="loginUserBusinessName" disabled class="disbledCls business-name" formControlName="businessnameField" style="padding: 0 !important;"/>
              <mat-error *ngIf="(submitted || f.businessnameField.touched || f.businessnameField.dirty) && f.businessnameField.errors">
                <i *ngIf="f.businessnameField.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <!-- Error Message -->
            <!--location-->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Farm Site</mat-label>
              <mat-select id="location" formControlName="locationameField" name="location"
                          [(ngModel)]="transaction.farm_site_id" (selectionChange)="getLocationnamebyLocationId(); getAllpondsByFarmsiteId(); ponddropdownList = []; pondselectedItems=[] ">
                <mat-option value="undefined" disabled>Select Farm site</mat-option>
                <mat-option *ngFor="let farmsite of farmSites" [value]="farmsite.id">
                  {{ (farmsite?.farmNameAtLocation) }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="f.locationameField.invalid"><i>Select farm site</i></mat-hint>
              <mat-hint *ngIf="f.locationameField.valid"><i>Farm site selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.locationameField.touched || f.locationameField.dirty) && f.locationameField.errors">
                <i *ngIf="f.locationameField.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <!--item-->
            <mat-form-field appearance="outline" class="w-100" floatLabel="always">
              <mat-label>Item</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="items" autocomplete="off" formControlName="itemnameField"
                     placeholder="Search item" (keyup)="filterItems()" (focus)="filteredItemOptions = inventoryExpenseItems;"
                     [matAutocomplete]="itemAuto"/>
              <mat-autocomplete #itemAuto="matAutocomplete" (optionSelected)="selectItemOption($event.option.value)">
                <mat-option *ngFor="let item of inventoryExpenseItems" [value]="item">
                  {{ item.item_name }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint *ngIf="f.itemnameField.invalid"><i>Select item</i></mat-hint>
              <mat-hint *ngIf="f.itemnameField.valid"><i>Item selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.itemnameField.touched || f.itemnameField.dirty) && f.itemnameField.errors">
                <i *ngIf="f.itemnameField.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <!--Transaction type-->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Transaction Type</mat-label>
              <mat-select id="transactionTypeField" formControlName="transactionTypeField" name="transactionTypeField"
                          [(ngModel)]="transaction.transaction_type_id" (selectionChange)="findTransactiontypeName(); onhandquantity(); getVendors(); paymentTransaction.vendor_id = undefined; transaction.unit_cost = undefined;">
                <mat-option value="undefined" disabled>Select Transaction Type</mat-option>
                <mat-option *ngFor="let type of transactionTypes" [value]="type.id">
                  {{ type?.transaction_type }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="f.transactionTypeField.invalid"><i>Select transaction type</i></mat-hint>
              <mat-hint *ngIf="f.transactionTypeField.valid"><i>Transaction type selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.transactionTypeField.touched || f.transactionTypeField.dirty) && f.transactionTypeField.errors">
                <i *ngIf="f.transactionTypeField.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <!--tank selection if selected item is expense-->
            <mat-form-field appearance="outline" class="w-100" *ngIf="stockable == false && tabIndex == 1">
              <mat-label>Select Tank</mat-label>
              <mat-select formControlName="tankid" [(ngModel)]="pondselectedTankIds" multiple placeholder="Choose options">
                <mat-option *ngFor="let option of ponddropdownList" [value]="option.pondID">
                  {{ option.itemName }}
                </mat-option>
              </mat-select>
              <mat-hint><i>Choose one or more tank</i></mat-hint>
            </mat-form-field>
            <!--date, stage, quantity, uom and unit cost row-->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Date</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="transactionDateField" [formControl]="transactionDateControl" placeholder="Choose date" autocomplete="off" readonly
              [max]="maxDate" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Stage</mat-label>
              <mat-select id="stage" formControlName="stage" name="stage" [(ngModel)]="transaction.stage">
                <mat-option value="undefined" disabled>Select Stage</mat-option>
                <mat-option value="Growout">Growout</mat-option>
                <mat-option value="Preparatory">Preparatory</mat-option>
                <mat-option value="PostHarvest">PostHarvest</mat-option>
              </mat-select>
              <mat-hint *ngIf="f.stage.invalid"><i>Select stage</i></mat-hint>
              <mat-hint *ngIf="f.stage.valid"><i>Stage selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.stage.touched || f.stage.dirty) && f.stage.errors">
                <i *ngIf="f.stage.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <!--display latesd on hand quantity if selected item have latest details-->
            <div class="form-field"
                 *ngIf="(transactionName == 'Purchase(+)') && (transactionOnHand && transactionOnHand.onHandQuantities.length>0) && (transactionOnHand && transactionOnHand.transaction.length>0)">
              <p>Onhand Quantity: <span
                *ngFor="let onhand of transactionOnHand && transactionOnHand.onHandQuantities">{{ onhand && onhand.onHand }} {{ onhand && onhand.UOMMaster && onhand.UOMMaster.name }}</span>
              </p>
            </div>
            <div class="form-field"
                 *ngIf="(transactionName == 'Purchase(+)') && (transactionOnHand && transactionOnHand.onHandQuantities.length>0) && (transactionOnHand && transactionOnHand.transaction.length>0)">
              <p>Last Purchased Price
                <span *ngFor="let transaction of transactionOnHand && transactionOnHand.transaction">
                    ₹ {{ (transaction && transaction.unit_cost) | currencyFormat }}</span>
              </p>
            </div>

            <div class="form-field"
                 *ngIf="(transactionName == 'Purchase(+)') && (transactionOnHand && transactionOnHand.onHandQuantities.length>0) && (transactionOnHand && transactionOnHand.transaction.length>0)"></div>
            <!--quantity-->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Quantity</mat-label>
              <input matInput id="thirty" type="text" autocomplete="off" [(ngModel)]="transaction.quantity" (keypress)="numberValidation($event)" formControlName="transactionQuantityField" placeholder="Enter quantity"/>
              <mat-hint><i> Alphanumeric characters</i></mat-hint>
              <mat-error *ngIf="(submitted || f.transactionQuantityField.touched || f.transactionQuantityField.dirty) && f.transactionQuantityField.errors">
                <i *ngIf="f.transactionQuantityField.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100" *ngIf="uomData && uomData.length != 1">
              <mat-label>UOM</mat-label>
              <mat-select id="transactionUomField" formControlName="transactionUomField" name="transactionUomField"
                          [(ngModel)]="transaction.uom_id">
                <mat-option value="undefined" disabled>Select UOM</mat-option>
                <mat-option *ngFor="let uom of uomData" [value]="uom.id"> {{ uom?.name }} </mat-option>
              </mat-select>
              <mat-hint *ngIf="f.transactionUomField.invalid"><i>Select uom</i></mat-hint>
              <mat-hint *ngIf="f.transactionUomField.valid"><i>UOM selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.transactionUomField.touched || f.transactionUomField.dirty) && f.transactionUomField.errors">
                <i *ngIf="f.transactionUomField.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100" *ngIf="uomData && uomData.length == 1">
              <mat-label>UOM</mat-label>
              <mat-select id="transactionUomField" formControlName="transactionUomField" name="transactionUomField"
                          [(ngModel)]="transaction.uom_id">
                <mat-option value="undefined" disabled>Select UOM</mat-option>
                <mat-option *ngFor="let uom of uomData" [value]="uom.id"> {{ uom?.name }} </mat-option>
              </mat-select>
              <mat-hint *ngIf="f.transactionUomField.invalid"><i>Select uom</i></mat-hint>
              <mat-hint *ngIf="f.transactionUomField.valid"><i>UOM selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.transactionUomField.touched || f.transactionUomField.dirty) && f.transactionUomField.errors">
                <i *ngIf="f.transactionUomField.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <!--uom selection-->
            <!--unit cost and value-->
            <mat-form-field appearance="outline" class="w-100" *ngIf="(((findinginventorytruefalse == true) && (transactionName == 'Balance migration(+)' || transactionName == 'Purchase(+)')) || ((findinginventorytruefalse == false) && (transactionName == 'Issue(-)' || transactionName == 'Reversal(-)'))) && transaction.transaction_type_id != undefined">
              <mat-label>Unit Cost</mat-label>
              <input matInput id="unitCostfield" (keypress)="numberValidation($event)" [(ngModel)]="transaction.unit_cost" type="text" autocomplete="off" formControlName="unitCostfield" placeholder="Unit cost"/>
              <mat-hint><i> Alphanumeric characters</i></mat-hint>
            </mat-form-field>
            <!--GST Percentage Entry field-->
            <mat-form-field appearance="outline" class="w-100" *ngIf="((((findinginventorytruefalse == true) && (transactionName == 'Balance migration(+)' || transactionName == 'Purchase(+)')) || ((findinginventorytruefalse == false) && (transactionName == 'Issue(-)' || transactionName == 'Reversal(-)'))) && transaction.transaction_type_id != undefined) && (['EMPLOYEE', 'Farmer', 'Business Admin'].includes(loginPersonType))">
              <mat-label>Enter GST(%)</mat-label>
              <input matInput id="gst" (keypress)="numberValidation($event)" [(ngModel)]="transaction.gst_percent" type="text" autocomplete="off" formControlName="gstfield" placeholder="Enter GST(%)"/>
              <mat-hint><i> Alphanumeric characters</i></mat-hint>
            </mat-form-field>
            <!--value-->
            <mat-form-field appearance="outline" class="w-100"
                            *ngIf="(((findinginventorytruefalse == true) && (transactionName == 'Balance migration(+)' || transactionName == 'Purchase(+)')) || ((findinginventorytruefalse == false) && (transactionName == 'Issue(-)' || transactionName == 'Reversal(-)'))) && transaction.transaction_type_id != undefined">
              <mat-label>Value (Includes GST if provided)</mat-label>
              <input matInput id="unitValueField" formControlName="unitValueField" [value]="calculateTransactionValue()" type="text" autocomplete="off" placeholder="" readonly />
              <mat-hint><i>Numbers</i></mat-hint>
            </mat-form-field>
            <!--invoice number, attachemnt, and notes-->
            <mat-form-field appearance="outline" class="w-100" *ngIf="(transaction.transaction_type_id == 1 || transaction.transaction_type_id == 2 || (this.transaction.transaction_type_id == 3 && this.findinginventorytruefalse == false))">
              <mat-label>Invoice Number</mat-label>
              <input matInput id="invoicenumber" (keypress)="numberValidation($event)" [(ngModel)]="paymentTransaction.invoice_number" type="text" autocomplete="off" formControlName="invoiceVoucher" placeholder=""/>
              <mat-hint><i> Alphanumeric characters</i></mat-hint>
            </mat-form-field>
            <!--note-->
            <div class="form-field">
                  <textarea type="text" name="desc" class="form-control" formControlName="description" [(ngModel)]="transaction.notes" autocomplete="off" placeholder=" "
                            [ngClass]="{ 'is-invalid': registerForm && f.description.errors }"></textarea>
              <label>Notes</label>
              <div *ngIf="submitted && f.description.errors">
                <div *ngIf="f.description.errors.maxlength" class="field-validation-error-message">
                  <img src="assets/images/New_Icons/error-message.svg" height="20px" width="20px">
                  <span>Maximum 200 characters allowed</span>
                </div>
              </div>
            </div>
            <!--if transactio type id is 4 transfer/return-->
            <mat-form-field appearance="outline" class="w-100" floatLabel="always" *ngIf="transaction.transaction_type_id == 4">
              <mat-label>Search Vendor Name</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="vendor" autocomplete="off" formControlName="vendorSelection"
                     placeholder="Search business" (keyup)="filterVendors($event)" (focus)="filteredVendorNames = vends"
                     [matAutocomplete]="venderAuto"/>
              <mat-autocomplete #venderAuto="matAutocomplete" (optionSelected)="selectVendorOption($event.option.value)">
                <mat-option *ngFor="let option of filteredVendorNames" [value]="option">
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint *ngIf="f.vendorSelection.invalid"><i>Select vendor</i></mat-hint>
              <mat-hint *ngIf="f.vendorSelection.valid"><i>Vendor selected</i></mat-hint>
              <mat-error *ngIf="submitted && f.vendorSelection.errors">
                <i *ngIf="f.vendorSelection.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <!--payment details-->
            <mat-form-field appearance="outline" class="w-100" floatLabel="always" *ngIf="(transaction.transaction_type_id == 1 || transaction.transaction_type_id == 2 || (this.transaction.transaction_type_id == 3 && this.findinginventorytruefalse == false))">
              <mat-label>Vendor Name</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="vendor" autocomplete="off" formControlName="vendorSelection"
                     placeholder="Search vendor" (keyup)="filterVendors($event)" (focus)="filteredVendorNames = vends"
                     [matAutocomplete]="venderAuto"/>
              <mat-autocomplete #venderAuto="matAutocomplete" (optionSelected)="selectVendorOption($event.option.value)">
                <mat-option *ngFor="let option of filteredVendorNames" [value]="option">
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint *ngIf="f.vendorSelection.invalid"><i>Select vendor</i></mat-hint>
              <mat-hint *ngIf="f.vendorSelection.valid"><i>Vendor selected</i></mat-hint>
              <mat-error *ngIf="submitted && f.vendorSelection.errors">
                <i *ngIf="f.vendorSelection.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100" *ngIf="(transaction.transaction_type_id == 1 || transaction.transaction_type_id == 2 || (this.transaction.transaction_type_id == 3 && this.findinginventorytruefalse == false))">
              <mat-label>Enter Paid Amount</mat-label>
              <input matInput id="amount" type="text" autocomplete="off" [(ngModel)]="paymentTransaction.paid_amount" (keypress)="numberValidation($event)" formControlName="amountpaid" placeholder=""/>
              <mat-hint><i>Numbers</i></mat-hint>
            </mat-form-field>
            <!--File Upload in Screen-->
            <div class="form-field file-container" style="width: 30%;flex-direction: row;">
              <div class="file-name-div">
                <p class="file-title">Upload invoice</p>
                <span class="inventory-file-name">Upload file</span>
              </div>
              <div class="file-upload-div">
                <input type="file" name="file" id="imageUpload" (change)="fileupload($event)"
                       style="display: none;" formControlName="fileAttachment"
                       autocomplete="off" accept="image/jpeg, image/jpg, image/png, image/gif"/>
                <span class="inventory-browse-file" (click)="browseFile()">Browse</span>
              </div>
            </div>
            <!--Image Dispaly Field-->
            <div class="image-display" *ngIf="selectedbase64file">
              <diV><i (click)="remove()" class="fa fa-times" aria-hidden="true" style="float: right"></i></diV>
              <span>{{ fileName }}</span><img src="{{selectedbase64file}}" width="56" height="56">
            </div>
          </div>
        </form>
      </div>
      <div class="row">
        <div class="buttons-div" style="padding-bottom: 30px;">
          <div class="transactions-button-container">
            <button class="transaction-submit-button" (click)="inventoryTransaction()"
                    [disabled]="submitButtonDisabled">
              <span class="icon"><img src="../../../../../assets/images/New_Icons/tick-icon.svg"></span>
              <span class="text">Submit</span>
            </button>
          </div>
          <div class="transactions-button-container">
            <button class="transaction-close-button" (click)="clearTransactionData($event)">
              <span class="icon"><img src="../../../../../assets/images/New_Icons/cross-icon.svg"></span>
              <span class="text">Cancel</span>
            </button>
          </div>
        </div>
      </div>
      <div class="panel-body table-responsive transactiontable" *ngIf="issubmitted">
        <table class="table">
          <thead class="thead-light">
          <tr>
            <th scope="col">S.No.</th>
            <th scope="col">Business Name</th>
            <th scope="col">Location</th>
            <th scope="col" *ngIf="paymentDetails && paymentDetails.Vendor && paymentDetails.Vendor">Vendor Name
            </th>
            <th scope="col">Item Name</th>
            <th scope="col">Opening Stock</th>
            <th scope="col">Transfer/Return</th>
            <th scope="col">On Hand</th>
            <th scope="col">Total Consumption</th>
            <th scope="col">Value</th>
            <th scope="col" *ngIf="paymentDetails && paymentDetails.unpaid_amount">Unpaid Amount</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td scope="row">1</td>
            <td>{{ latestTransactionData && latestTransactionData.business_name }}</td>
            <td>{{ latestTransactionData && latestTransactionData.farm_location }}</td>
            <td
              *ngIf="paymentDetails && paymentDetails.Vendor && paymentDetails.Vendor">{{ paymentDetails && paymentDetails.Vendor && paymentDetails.Vendor.name }}
            </td>
            <td>{{ latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].ItemMaster && latestTransactionData.transactionResult[0].onHand[0].ItemMaster.item_name }}</td>
            <td>{{ (latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].opening_stock) | currencyFormat }} {{ latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].UOMMaster && latestTransactionData.transactionResult[0].onHand[0].UOMMaster.name }}</td>
            <td>{{ (latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].transfer) | currencyFormat }} {{ latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].UOMMaster && latestTransactionData.transactionResult[0].onHand[0].UOMMaster.name }}</td>
            <td>{{ (latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].onHand) | currencyFormat }} {{ latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].UOMMaster && latestTransactionData.transactionResult[0].onHand[0].UOMMaster.name }}</td>
            <td>{{ (latestTransactionData && latestTransactionData.transactionResult[0].totalConsumption) | currencyFormat }} {{ latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].UOMMaster && latestTransactionData.transactionResult[0].onHand[0].UOMMaster.name }}</td>
            <td
              *ngIf="(latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].ItemMaster && latestTransactionData.transactionResult[0].onHand[0].ItemMaster.isInventory == false)">{{ ((latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].value) >= 0 ? (((latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].value) * -1)| currencyFormat) : (((latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].value) * -1) |  currencyFormat)) }}
            </td>
            <td
              *ngIf="(latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].ItemMaster && latestTransactionData.transactionResult[0].onHand[0].ItemMaster.isInventory == true)">{{ ((latestTransactionData && latestTransactionData.transactionResult[0] && latestTransactionData.transactionResult[0].onHand[0] && latestTransactionData.transactionResult[0].onHand[0].value) |  currencyFormat) }}
            </td>
            <td
              *ngIf="paymentDetails && paymentDetails.unpaid_amount">{{ paymentDetails && paymentDetails.unpaid_amount }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
